module.exports = __webpack_public_path__ + "img/icon-close@2x.c6ec057e.png";